import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { uri: String, playUrl: String }
  static targets = ["button"]

  play(event) {
    event.preventDefault()
    if (!this.hasButtonTarget) return

    const btn = this.buttonTarget
    btn.disabled = true
    btn.textContent = "Playing…"

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.playUrlValue, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf },
      body: JSON.stringify({ uri: this.uriValue })
    })
      .then(r => r.json())
      .then(data => {
        if (data.ok) {
          btn.textContent = "Playing"
          setTimeout(() => { btn.textContent = "Play"; btn.disabled = false }, 3000)
        } else {
          btn.disabled = false
          btn.textContent = "Play"
          window.open(this.spotifyWebUrl(), "_blank", "noopener")
        }
      })
      .catch(() => { btn.textContent = "Play"; btn.disabled = false })
  }

  spotifyWebUrl() {
    const uri = this.uriValue
    if (uri.startsWith("spotify:")) {
      const parts = uri.split(":")
      return `https://open.spotify.com/${parts[1]}/${parts[2]}`
    }
    return uri
  }
}
